import * as React from "react";

import { TabsBanner } from "@v1/components/editor/page/element-editor/components/banners/TabsBanner";
import { selectDraftComponentContext } from "@v1/reducers/core-reducer";
import { useEditorSelector } from "@v1/store/store";

const StickyBanners: React.FC = () => {
  const context = useEditorSelector(selectDraftComponentContext);

  if (!context) {
    return null;
  }

  const hasChildren =
    Boolean(context?.state?.collapsibleV2) ||
    Boolean(context?.state?.tabsBlock);

  if (!hasChildren) {
    return null;
  }

  return context?.state?.tabsBlock ? (
    <div
      className="sticky top-0 flex flex-col items-stretch"
      style={{ zIndex: 1000 }}
    >
      <TabsBanner />
    </div>
  ) : null;
};

export default StickyBanners;
